import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.SourcePieChartView extends Monitoring.Views.Charts.PieChartView

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.source')
    @title_en = I18n.t('monitoring.dashboard.charts.source', {'locale': 'en'})
    super(@options)
    @name = 'type'

  getNewQuery: (event) ->
    name = event.point.code || event.point.name
    query = @searchQuery.deepCopy()
    query.set(@name, [ name ])
    return query

  _benchmarkDataFromResponse: () ->
    _.each(@dataBenchmark.benchmark_data[0].data, (data) -> data.name = data.name.toLowerCase())
